import { IconButton } from "@mui/material";
import { ArrowUpward, ArrowDownward } from "@mui/icons-material";
import { useNotify, useRefresh, Datagrid, TextField, FunctionField } from "react-admin";
import { useState, useEffect } from "react";
import { candidateRequests } from "api/candidateApi";
import { administrationRequests } from "api/administrationApi";
import { settings } from "app";
import ConfirmModal from "server/components/Modals/ConfirmModal";
import LoadingActionButton from "server/components/LoadingActionButton";
import SwapVertIcon from "@mui/icons-material/SwapVert";
import dataProvider from "server/dataProvider";

const SpecialitiesPrioritySlotDialog = ({ candidacyId, specialities, disabled }) => {
  const notify = useNotify();
  const refresh = useRefresh();
  const [items, setItems] = useState([]);

  useEffect(() => {
    if (specialities && specialities.length > 0) {
      const ids = specialities.map(item => item.specialityId);
      dataProvider
        .getMany(administrationRequests.getSpecialitiesSelect(), { ids, filterByUser: true })
        .then(({ data }) => {
          const combined = specialities.map(item => {
            const speciality = data.find(s => s.id === item.specialityId);
            return {
              id: item.specialityId,
              specialityId: item.specialityId,
              priority: item.priority,
              name: speciality.name,
            };
          });
          setItems(combined);
        })
        .catch(() => {
          notify("Грешка при зареждане на специалностите", { type: "error" });
          setItems([]);
        });
    } else {
      setItems([]);
    }
  }, [specialities, notify]);

  const moveItem = (index, direction) => {
    const newItems = [...items];
    const targetIndex = index + direction;
    if (targetIndex < 0 || targetIndex >= items.length) return;
    const temp = newItems[index];
    newItems[index] = newItems[targetIndex];
    newItems[targetIndex] = temp;
    setItems(newItems);
  };

  const handleSubmit = async () => {
    const payload = items.map((item, index) => ({
      specialityId: item.specialityId,
      priority: index + 1,
    }));

    await dataProvider.customRequest(
      candidateRequests.updateCandidacySpecialityPriorities(candidacyId),
      payload,
      "PUT",
    );
    notify("Успешна промяна", { type: "success" });
    refresh();
  };

  return (
    <ConfirmModal
      titleContent="Разместване на специалности"
      onConfirm={handleSubmit}
      triggerButton={
        <LoadingActionButton
          label="Разместване на желания"
          icon={<SwapVertIcon />}
          disabled={specialities?.length <= 1 || disabled}
          sx={{ mt: 2, mr: 2 }}
        />
      }
    >
      <Datagrid
        data={items}
        total={items.length}
        ids={items.map(i => i.id)}
        rowClick={false}
        bulkActionButtons={false}
        sx={settings.style.secondaryDatagrid}
      >
        <TextField
          source="name"
          label="Специалност"
          sortable={false}
        />

        <FunctionField
          label="Желание"
          render={record => items.findIndex(i => i.id === record.id) + 1}
        />

        <FunctionField
          render={record => (
            <>
              <IconButton
                onClick={() =>
                  moveItem(
                    items.findIndex(i => i.id === record.id),
                    -1,
                  )
                }
                disabled={items.findIndex(i => i.id === record.id) === 0}
              >
                <ArrowUpward />
              </IconButton>
              <IconButton
                onClick={() =>
                  moveItem(
                    items.findIndex(i => i.id === record.id),
                    1,
                  )
                }
                disabled={items.findIndex(i => i.id === record.id) === items.length - 1}
              >
                <ArrowDownward />
              </IconButton>
            </>
          )}
        />
      </Datagrid>
    </ConfirmModal>
  );
};

export default SpecialitiesPrioritySlotDialog;
